const property = {
  property: {
    breadcrumbProperty: 'Propriedade',
    backToResults: 'Voltar para resultados',
    guestsCount: '{{count}} hóspedes',
    loadingMessage: 'Carregando detalhes da propriedade...',
    errorTitle: 'Propriedade não encontrada',
    errorMessage: 'Não foi possível carregar os detalhes desta propriedade. Verifique o link ou tente novamente.',
    availableUnits: '{{count}} unidade{{suffix}} disponíve{{suffix2}}',
    noAvailability: 'Sem disponibilidade',
    photoAlt: 'Foto {{index}}',
    aboutProperty: 'Sobre a propriedade',
    amenities: 'Comodidades',
    accommodations: 'Acomodações',
    pricingForDates: 'Preços para {{nights}} {{nightLabel}} · {{checkIn}} → {{checkOut}}',
    selectDatesHint: 'Selecione datas na busca para ver preços e disponibilidade.',
    available: 'Disponível',
    unavailable: 'Indisponível',
    upToGuests: 'Até {{count}} hóspedes',
    included: 'incluídos',
    perNightTotal: '/ noite · total',
    unavailableForDates: 'Indisponível para estas datas',
    bookNow: 'Reservar agora',
    noUnitsAvailable: 'Nenhuma unidade disponível para as datas selecionadas.',
    tryOtherDates: 'Tente outras datas',
    reviews: 'Avaliações',
    verified: 'Verificada',
    location: 'Localização',
    viewOnMaps: 'Ver no Google Maps',
    contact: 'Contato',
    officialSite: 'Site oficial',
    whatsappContact: 'Falar no WhatsApp',
    pageTitle: '{{name}} - Reserve Connect',
    pageTitleFallback: 'Propriedade - Reserve Connect',
    pageDescription: '{{description}} em {{city}}. Veja disponibilidade e preços reais.',
    pageDescriptionFallback: 'Detalhes da propriedade no Reserve Connect.',

    // Cancellation policy display
    policyFlexible: 'Cancelamento Grátis',
    policyFlexibleBadge: 'Cancelamento Grátis',
    policyFlexibleDesc: 'Cancele até 24 horas antes do check-in e receba reembolso integral.',
    policyModerate: 'Moderado',
    policyModerateBadge: 'Moderado',
    policyModerateDesc: 'Cancele até 5 dias antes para reembolso integral. Até 24 horas antes, 50% de reembolso.',
    policyStrict: 'Rigoroso',
    policyStrictBadge: 'Rigoroso',
    policyStrictDesc: 'Cancele até 7 dias antes para 50% de reembolso. Após esse prazo, não há reembolso.',
    policyUnknown: 'Política de cancelamento',
    policyUnknownDesc: 'Consulte os termos da reserva para detalhes sobre cancelamento.',
    policyLearnMore: 'Saiba mais',
  },
};
export default property;
